define(
    'NMSDesignSystem.GlobalFooter',
    [
        'Footer.View',
        'nms_footer.tpl'
    ],
    function NMSDesignSystemGlobalFooter(
        FooterViewModule,
        nmsFooterTpl
    ) {
        'use strict';

        var FooterView = FooterViewModule && (
            FooterViewModule.FooterView || FooterViewModule
        );
        var pilotClass = 'nms-global-footer-pilot';
        var productionRestoreClass = 'nms-production-footer-restore';

        function isLocalPreview() {
            return typeof window !== 'undefined' &&
                (/(?:shopping|checkout|my_account)-local\.ssp$/i.test(window.location.pathname) ||
                    window.location.hostname === 'sca-sandbox.ethanablatt.com' ||
                    window.location.hostname === 'buyflu-sandbox.ethanablatt.com');
        }

        function isProductionStorefront() {
            return typeof window !== 'undefined' &&
                !isLocalPreview() &&
                /^(?:(?:www\.)?nmsincusa\.com|buyflushots\.nmsincusa\.com)$/i.test(
                    window.location.hostname
                );
        }

        function sync() {
            var footer = document.querySelector('#site-footer');

            document.body.classList.toggle(pilotClass, isLocalPreview() && !!footer);
            document.body.classList.toggle(
                productionRestoreClass,
                isProductionStorefront() && !!footer
            );
        }

        function scheduleSync() {
            sync();
        }

        function enforceFooterTemplate(View) {
            var originalRender;

            if (!View || !View.prototype || View.prototype.nmsFooterTemplateEnforced) {
                return;
            }

            originalRender = View.prototype.render;
            View.prototype.template = nmsFooterTpl;
            View.prototype.render = function renderNMSFooter() {
                this.template = nmsFooterTpl;
                return originalRender.apply(this, arguments);
            };
            View.prototype.nmsFooterTemplateEnforced = true;
        }

        function enforceFooterInstance(footerView, renderNow) {
            if (!footerView) {
                return;
            }

            enforceFooterTemplate(footerView.constructor);
            footerView.template = nmsFooterTpl;
            if (renderNow && footerView.render) {
                footerView.render();
            }
        }

        function wrapFooterChildViewFactory(layoutView) {
            var childViews = layoutView && layoutView.childViews;
            var originalFooterFactory = childViews && childViews.Footer;

            if (!originalFooterFactory || originalFooterFactory.nmsFooterFactoryWrapped) {
                return;
            }

            childViews.Footer = function createNMSFooterForRoute() {
                var footerView = originalFooterFactory.apply(this, arguments);

                enforceFooterInstance(footerView, false);
                return footerView;
            };
            childViews.Footer.nmsFooterFactoryWrapped = true;
        }

        return {
            mountToApp: function mountToApp(container) {
                var layout = container && container.getComponent
                    ? container.getComponent('Layout')
                    : null;
                var layoutView = container && container.getLayout
                    ? container.getLayout()
                    : null;
                var footerView = layoutView && layoutView.footerViewInstance;

                enforceFooterTemplate(FooterView);

                wrapFooterChildViewFactory(layoutView);
                enforceFooterInstance(footerView, true);

                scheduleSync();

                if (layout) {
                    layout.on('afterShowContent', function enforceRouteFooter() {
                        var currentLayout = container.getLayout && container.getLayout();
                        var currentFooter = currentLayout && currentLayout.footerViewInstance;
                        var needsRender = !!(
                            currentFooter && currentFooter.template !== nmsFooterTpl
                        );

                        wrapFooterChildViewFactory(currentLayout);
                        enforceFooterInstance(currentFooter, needsRender);
                        scheduleSync();
                    });
                }
            }
        };
    }
);
